import React from "react";

// Banner disattivato su richiesta: il sito è operativo. Per riattivarlo, ripristinare il markup sottostante.
export function PrototypeBanner() {
  return null;
}
